(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tallah-fit-sizing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tallah-size-guide')) {
  customElements.define('tallah-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.onChange = (event) => {
        const picker = event.target.closest('variant-selects');
        if (picker?.closest('product-info') === this.productInfo) {
          this.picker = picker;
          this.pickerId = picker.id;
          this.updateSelection(picker);
        }
      };
      this.productInfo?.addEventListener('change', this.onChange, true);
      this.picker = this.productInfo?.querySelector('variant-selects');
      this.pickerId = this.picker?.id;
      this.updateSelection(this.picker);
      this.observer = new MutationObserver((records) => {
        const pickerChanged = records.some((record) => record.target.closest?.('variant-selects') || [...record.addedNodes, ...record.removedNodes].some((node) =>
          node.nodeType === 1 && (node.matches('variant-selects') || node.querySelector('variant-selects'))
        ));
        if (!pickerChanged) return;
        const pickers = [...this.productInfo.querySelectorAll('variant-selects')];
        this.picker = pickers.find((picker) => picker.id === this.pickerId) || (pickers.length === 1 ? pickers[0] : null);
        this.updateSelection(this.picker);
      });
      if (this.productInfo) this.observer.observe(this.productInfo, { childList: true, subtree: true });
    }
    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.onChange, true);
      this.observer?.disconnect();
    }
    updateSelection(picker = this.picker) {
      const groups = this.querySelectorAll('[data-sizing-group]');
      if (!groups.length) return;
      if (this.hasAttribute('data-show-all-groups')) {
        groups.forEach((group) => { group.hidden = false; });
        const unavailable = this.querySelector('[data-sizing-unavailable]');
        if (unavailable) unavailable.hidden = true;
        return;
      }
      const selected = new Map();
      picker?.querySelectorAll('.product-form__input').forEach((field) => {
        const label = field.querySelector('[data-selected-swatch-value]');
        const input = field.querySelector('select, input:checked');
        if (label && input) selected.set(label.dataset.selectedSwatchValue, input.value);
      });
      let found = false;
      groups.forEach((group) => {
        let nameAliases = [];
        let valueAliases = [];
        try { nameAliases = JSON.parse(group.dataset.optionNames || '[]') || []; } catch {}
        try { valueAliases = JSON.parse(group.dataset.optionValues || '[]') || []; } catch {}
        const names = [group.dataset.optionName, ...(Array.isArray(nameAliases) ? nameAliases : [])];
        const values = [group.dataset.optionValue, ...(Array.isArray(valueAliases) ? valueAliases : [])];
        const matches = names.some((name) => selected.has(name) && values.includes(selected.get(name)));
        group.hidden = !matches;
        found ||= matches;
      });
      const unavailable = this.querySelector('[data-sizing-unavailable]');
      if (unavailable) unavailable.hidden = found;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
